






























import { API } from "@/shared/api";
import productoModule from "@/store/modules/producto-module";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {
    MaterialCard: () => import("@/components/Cards/MaterialCard.vue"),
    DocumentsHandler: () => import("@/views/Documentos/DocumentsHandler.vue"),
    Xbtn: () => import("@/components/buttons/x-btn.vue"),
  },
  $_veeValidate: { validator: "new" },
})
export default class CajasImagenes extends Vue {
  public get_url() {
    return {
      url: API.RepositorioInformes + "/cajas/1",
      url_download: API.webApiBaseImagenes + "1",
    };
  }
  public cargando = false;

  public async generar_todas_las_cajas() {
    this.cargando = true;
    try {
      await productoModule.getcajas();
      for (const caja of productoModule.cajas) {
        try {
          await productoModule.crearImagen(caja.localizador);
        } catch (error) {
          console.error(
            "Error al crear imagen para la caja:",
            caja.localizador,
            error
          );
        }
      }
    } finally {
      this.cargando = false;
    }
  }
  public cancelar() {
    this.$router.back();
  }
}
